import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSubjects } from '../../hooks/useSubjects';
import Button from '../../components/common/Button';
import Card from '../../components/common/Card';
import Table from '../../components/common/Table';
import Input from '../../components/common/Input';
import { PlusIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const SubjectList = () => {
  const { subjects, loading, error, deleteSubject } = useSubjects();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredSubjects = subjects.filter(subject => {
    return subject.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
           subject.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this subject?')) {
      const result = await deleteSubject(id);
      if (result.success) {
        alert('Subject deleted successfully');
      } else {
        alert(result.error || 'Failed to delete subject');
      }
    }
  };

  const columns = [
    {
      header: 'Subject Code',
      accessor: (row) => row.code,
      cell: (value) => value
    },
    {
      header: 'Subject Name',
      accessor: (row) => row.name,
      cell: (value) => value
    },
    {
      header: 'Description',
      accessor: (row) => row.description,
      cell: (value) => value || '-'
    },
    {
      header: 'Actions',
      accessor: (row) => row.id,
      cell: (value) => (
        <div className="flex space-x-2">
          <Link to={`/subjects/${value}/edit`}>
            <Button variant="outline" size="sm">Edit</Button>
          </Link>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => handleDelete(value)}
            className="text-red-600 hover:text-red-800"
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold text-gray-900">Subjects Management</h1>
        <Link to="/subjects/new">
          <Button>
            <PlusIcon className="h-5 w-5 mr-1" />
            Add Subject
          </Button>
        </Link>
      </div>
      
      <Card>
        <div className="mb-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <Input
              type="text"
              placeholder="Search subjects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>
        
        {loading ? (
          <div className="text-center py-8">Loading subjects...</div>
        ) : error ? (
          <div className="text-center py-8 text-red-500">Error: {error}</div>
        ) : (
          <Table 
            columns={columns} 
            data={filteredSubjects} 
            emptyMessage="No subjects found"
          />
        )}
      </Card>
    </div>
  );
};

export default SubjectList;